import * as React from 'react';

import {
  withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';

import {Field} from '../components/form-def-field-fc';
import {getValueAtPath, setValueAtPathWithOpts} from '../form/helper';
import {
  FormHelperText
} from '@mui/material'
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
  container: {
    marginTop: 15,
    display: 'flex',
    width: '100%'
  },
  formDefField: {
    width: '100%'
  },
  displayText: {
    fontSize: '0.95rem'
  },
  fieldLabel: {
    width: '100%'
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props extends TextFieldProps {
  data: any;
  path: string;
  value: any | undefined;
  policyMessages: Array<any>;
  fieldDefinition: any;
  onChangeAtPath:? Function;
}

type State = {
  value?: any;
  clickActivated ?: boolean;
};

class AcknowledgementDocumentLink extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  
  originalMode: string;

  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});

    this.state = {
      value: props.value
    };
  }

    static register = () => {
        // console.log("Registering AcknowledgementDocumentLink")
        if(!Renderers.find("AcknowledgementDocumentLink")){
          // console.log("Registering AcknowledgementDocumentLink")
          Renderers.register("AcknowledgementDocumentLink", withStyles(styles)(AcknowledgementDocumentLink))
        }
      }

  handleDocumentClick = (evt) => {
    if(!this.state.clickActivated){
      this.setState({clickActivated: true})
    }
  }

  handleCommitChange = (attribute: string) => (val: any) => {
    const {path} = this.props;
    const {data} = this.state;
    setValueAtPathWithOpts(attribute, data, val, null)
    // Update the internal state first, but do not wait.
    this.setState({data: data});

    if (this.props.onCommitChange){
      this.props.onCommitChange(val)
    }

    // Let the parent know something changed
    if (this.props.onChangeAtPath) {
      this.props.onChangeAtPath(path + '/' + attribute, val);
    }
  };



  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {data, value, fieldDefinition, policyMessages} = this.props;
    const {clickActivated} = this.state;

    const linkUrl = fieldDefinition.url || `/static/documents/terms-and-conditions.pdf`

    // console.log("linkRUL", linkUrl)

    if(!clickActivated){
      // If the link has not been click, change the mode
      this.originalMode = "" + fieldDefinition.mode
      fieldDefinition.mode = "Read Only"
    } else {
      // If the link has been clicked, change it back
      fieldDefinition.mode = this.originalMode
    }

    return (
      <div>
        <FormHelperText>
          <a className={classes.displayText} target="_blank" href={linkUrl} onClick={this.handleDocumentClick}>View Terms and Conditions</a>
        </FormHelperText>
        <Field
          path={fieldDefinition.path || fieldDefinition.key}
          value={value}
          data={data}
          fieldDefinition={fieldDefinition}
          onCommitChange={this.handleCommitChange(fieldDefinition.path || fieldDefinition.key)}
          policyMessages={policyMessages}
        />

      </div>
    );
  }
}

export default withStyles(styles)(AcknowledgementDocumentLink);

